import script from "./SlotDays.vue?vue&type=script&setup=true&lang=js"
export * from "./SlotDays.vue?vue&type=script&setup=true&lang=js"

import "./SlotDays.vue?vue&type=style&index=0&id=324836b2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-324836b2"]])

export default __exports__